"use client";

import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { QuickInsightsItemProps } from "./types";
import React from "react";
import { cn } from "utils";

/**
 * QuickInsights component displays an icon with title and description.
 * Used for individual feature cards in the QuickInsightsItemProps component.
 */
export const QuickInsights: React.FC<QuickInsightsItemProps> = ({
  icon,
  title,
  onClick,
}) => {
  return (
    <div
      data-openreplay-label="HomeQuestionCard · QuickInsights · div"
      className={cn(
        "rounded-md py-[5px] px-2 flex flex-shrink-0 items-center gap-1 cursor-pointer overflow-hidden",
        "border border-border_white_transparent20 hover:bg-background_white_overlay5",
      )}
      data-tracking-scope={`recommend-question-prompt-${title}`}
      onClick={() => onClick?.(title || "")}
    >
      {icon && (
        <OspIcons
          name={icon || ""}
          className={"text-content_brand_primary"}
          size={16}
        />
      )}
      <h3
        aria-label="Quick Insights h3"
        data-openreplay-label="Quick Insights h3 Semantic"
        id="sem-quick-insights-h3"
        className="title_s text-content_primary line-clamp-1"
      >
        {title}
      </h3>
    </div>
  );
};
